var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\r\n            #Capa_1 {\r\n           \r\n      animation: joema 2900ms linear 0ms infinite normal\r\n    }\r\n\r\n\r\n    \r\n     ", "\r\n\r\n\r\n  @keyframes joema {\r\n    0% {\r\n      transform:rotate(-720deg);\r\n       opacity:0.90\r\n    }\r\n    100%{\r\n      transform:rotate(0deg);\r\n      opacity:0.20\r\n    }\r\n  }\r\n\r\n\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\r\n        fill: #fff;\r\n      }\r\n\r\n      "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175,97.87c-14.21,0-25.74-11.52-25.74-25.74V25.74c0-14.21,11.52-25.74,25.74-25.74s25.74,11.52,25.74,25.74v46.39c0,14.21-11.52,25.74-25.74,25.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.79,127.94c-6.59,0-13.17-2.51-18.2-7.54-10.05-10.05-10.05-26.34,0-36.4l32.76-32.76c10.05-10.05,26.34-10.05,36.4,0,10.05,10.05,10.05,26.35,0,36.4l-32.76,32.76c-5.03,5.02-11.61,7.54-18.2,7.54Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M324.26,200.74h-46.32c-14.21,0-25.74-11.52-25.74-25.74s11.52-25.74,25.74-25.74h46.32c14.21,0,25.74,11.52,25.74,25.74s-11.52,25.74-25.74,25.74Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M280.55,306.28c-6.59,0-13.17-2.51-18.2-7.54l-32.76-32.76c-10.05-10.05-10.05-26.35,0-36.4,10.05-10.05,26.34-10.05,36.4,0l32.76,32.76c10.05,10.05,10.05,26.34,0,36.4-5.03,5.02-11.61,7.54-18.2,7.54Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M175,350c-14.21,0-25.74-11.52-25.74-25.74v-46.32c0-14.21,11.52-25.74,25.74-25.74s25.74,11.52,25.74,25.74v46.32c0,14.21-11.52,25.74-25.74,25.74Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.45,306.28c-6.59,0-13.17-2.51-18.2-7.54-10.05-10.05-10.05-26.35,0-36.4l32.81-32.81c10.05-10.05,26.34-10.05,36.39,0,10.05,10.05,10.05,26.35,0,36.4l-32.81,32.81c-5.03,5.02-11.61,7.54-18.2,7.54Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.06,200.74H25.74c-14.21,0-25.74-11.52-25.74-25.74s11.52-25.74,25.74-25.74h46.32c14.21,0,25.74,11.52,25.74,25.74s-11.52,25.74-25.74,25.74Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M102.21,127.94c-6.59,0-13.17-2.51-18.2-7.54l-32.76-32.76c-10.05-10.05-10.05-26.35,0-36.4,10.05-10.05,26.34-10.05,36.4,0l32.76,32.76c10.05,10.05,10.05,26.34,0,36.4-5.03,5.02-11.61,7.54-18.2,7.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader01);
export default __webpack_public_path__ + "static/media/loader01.5f96896baf289c13428c639d6d8522f5.svg";
export { ForwardRef as ReactComponent };